export function pageWindow(total, { page = 1, size = 10 } = {}) {
  size = [10, 25, 50].includes(Number(size)) ? Number(size) : 10;
  const pages = Math.max(1, Math.ceil(total / size));
  page = Math.max(1, Math.min(pages, Math.floor(Number(page)) || 1));
  const start = (page - 1) * size;
  return {
    page,
    size,
    pages,
    start,
    end: Math.min(total, start + size),
    total,
  };
}
export function breadcrumbTrail(route, id, d) {
  const root = { label: "Dashboard", route: "dashboard" },
    lists = {
      products: "Products",
      collections: "Collections",
      orders: "Orders",
      payments: "Payments",
      customers: "Customers",
      coupons: "Coupons",
      settings: "Content / Settings",
      profile: "Profile",
      notifications: "Notifications",
    };
  if (route === "dashboard") return [root];
  if (lists[route]) return [root, { label: lists[route], route }];
  const spec = {
    product: ["products", "products", "name"],
    "product-edit": ["products", "products", "name"],
    collection: ["collections", "collections", "name"],
    "collection-edit": ["collections", "collections", "name"],
    order: ["orders", "orders", "id"],
    "order-new": ["orders", "orders", "id"],
    payment: ["payments", "payments", "id"],
    customer: ["customers", "customers", "name"],
    "customer-edit": ["customers", "customers", "name"],
    "coupon-edit": ["coupons", "coupons", "code"],
  }[route];
  if (!spec) return [root, { label: "Page not found" }];
  const [parent, records, key] = spec,
    record = d[records].find((r) => r.id === id),
    trail = [root, { label: lists[parent], route: parent }];
  if (route.endsWith("-edit")) {
    if (record) {
      const detail = route.replace("-edit", "");
      if (detail !== "coupon")
        trail.push({ label: record[key], route: detail, id: record.id });
      else {
        trail.push({ label: "Edit " + record[key] });
        return trail;
      }
      trail.push({ label: "Edit" });
    } else
      trail.push({
        label: id
          ? "Record not found"
          : {
              "product-edit": "Add Product",
              "collection-edit": "Add Collection",
              "customer-edit": "Add Customer",
              "coupon-edit": "Add New Coupon",
            }[route],
      });
  } else
    trail.push({
      label:
        route === "order-new"
          ? "Add Order"
          : record?.[key] || "Record not found",
    });
  return trail;
}
